import { postRequest } from "./requests";
import { endpoints } from "./urls";

const {
	submitForm,
	userCreation,
	otpValidation,
	resendOtpCode,
	login,
	forgotPassword,
	changePassword,
	verifyContactInfo,
} = endpoints;

const submitFormData = (rData) => postRequest(submitForm, rData);
const createUser = (rData) => postRequest(userCreation, rData);
const validateOtp = (rData) => postRequest(otpValidation, rData);
const resendOtp = (rData) => postRequest(resendOtpCode, rData);
const loginUser = (rData) => postRequest(login, rData);
const forgotPasswordUser = (rData) => postRequest(forgotPassword, rData);
const changePasswordUser = (rData) => postRequest(changePassword, rData);
const validateEmailCelphone = (rData) => postRequest(verifyContactInfo, rData);

export {
	submitFormData,
	createUser,
	validateOtp,
	resendOtp,
	loginUser,
	forgotPasswordUser,
	changePasswordUser,
	validateEmailCelphone,
};
